import React from 'react';
import { connect } from 'react-redux';
import paging, { onCategoryScroll, reFetchConfig } from '@/hooks/paging';
import CohortCards from '../components/CohortCards';
import CohortsPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/CohortsPanelContainer';
import CohortsFilters from './CohortsFilters';

const CohortsPanelNarrow = ({
  canCreate,
  canRead,
  category,
  cohorts,
  currentPage,
  fetchData,
  newCohortCode,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  total,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus, reFetchConfig(cohorts, { pageSize, total }));
  return (
    <CohortsPanelContainer readErrors={readErrors} canRead={canRead} className="aridhia-cohorts-panel-narrow">
      <div className="sticky-panel-header">
        <CohortsFilters category={category} className="aridhia-list-filter" fluid />
      </div>
      <CohortCards
        canCreate={canCreate}
        category={category}
        handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
        items={cohorts}
        itemsPerRow={1}
        newCohortCode={newCohortCode}
        onCheckBoxClick={(value) => onCheckBoxClick(category, value)}
        readErrors={readErrors}
        readStatus={readStatus}
        showStatus
        showTools
      />
    </CohortsPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortsPanelNarrow);
